<template>
  <div class="floating-scroll-button" :class="{ hidden: showMenu > 0 }" @click="scrollToTarget">
    <div class="button-text">{{ text }}</div>
    <div class="button-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m6 9 6 6 6-6"/>
      </svg>
    </div>
  </div>
</template>

<script setup>
import { composables } from '@/composables'

const props = defineProps({
  text: {
    type: String,
    default: 'Scroll to form'
  },
  targetId: {
    type: String,
    required: true
  }
})

const showMenu = composables().showMenu

const scrollToTarget = () => {
  const target = document.getElementById(props.targetId)
  if (target) {
    const targetRect = target.getBoundingClientRect()
    const offsetTop = window.pageYOffset + targetRect.top - (10 * 16) // 10rem converted to pixels (assuming 16px base font)

    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth'
    })
  }
}
</script>

<style scoped>
.floating-scroll-button {
  position: fixed;
  left: 2rem;
  bottom: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  z-index: 1000;
  transition: all 0.3s ease;
  opacity: 1;
  visibility: visible;
}

.floating-scroll-button.hidden {
  opacity: 0;
  visibility: hidden;
}

.floating-scroll-button:hover {
  cursor: pointer;
}

.button-text {
  writing-mode: vertical-lr;
  text-orientation: mixed;
  font-size: var(--normal);
  font-weight: 500;
  color: var(--dark);
  margin-bottom: 1rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.button-icon {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: transparent;
  border: 2px solid var(--dark);
  display: flex;
  align-items: center;
  justify-content: center;
}

.button-icon svg {
  width: 1.5rem;
  height: 1.5rem;
  color: var(--dark);
  transform: rotate(0deg);
}
</style>
